  var _learnq = window._learnq || [];

  document.addEventListener('DOMContentLoaded', function () {
    document.body.addEventListener('click', function (e) {
      if (e.target.matches('[type="submit"][name="add"]')) {
        setTimeout(function () {
          fetch('/cart.js')
            .then(res => res.json())
            .then(cart => {
              const items = cart.items.map(item => ({
                product_id: item.product_id,
                variant_id: item.variant_id,
                quantity: item.quantity,
                title: item.title,
                url: item.url,
                image: item.image, // ✅ Add product image URL here
                price: item.price / 100 // Optional: price in dollars
              }));

              const cartURL = items.map(i => `${i.variant_id}:${i.quantity}`).join(',');
              const fullCartURL = `https://${window.location.hostname}/cart/${cartURL}`;

              _learnq.push(['track', 'Added to Cart Custom', {
                cart_url: fullCartURL,
                items: items
              }]);
            });
        }, 500);
      }
    });
  });